export let openingHtmlString = `<!DOCTYPE html>
<html>

<head>
  <meta charset="utf-8">
  <title>Print</title>
  <link rel="stylesheet" type="text/css" href="/uploads/assets/iview/styles/iview.css">
  <style>
    body {
      background: #eee;
      margin: 0px;
      padding: 0px;
    }

    .w-100{
      width: 100%;
    }

    span {
      font-size: 10px;
    }

    label{
      font-size: 10px;
    }

    b {
      font-size: 12px;
    }

    b.sub-header {
      font-size: 10px;
    }

    .big-gap {
      gap: 120px !important;
    }

    .flex {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .flex-row {
      display: flex;
      flex-direction: row;
      align-items: baseline;
      gap: 5px;
    }

    .main-container {
      display: flex;
      flex-direction: column;
      min-height: 297mm !important;
      height: 297mm !important;
      max-height: 297mm !important;
      min-width: 210mm !important;
      max-width: 210mm !important;
      width: 210mm !important;
    }

    .match-info {
      display: flex;
      justify-content: space-between;
      gap: 10px;
    }

    .big-underline {
      position: relative;
      width: auto;
      min-width: 100px;
      border-bottom: 2px black solid;
      top: 2px;
    }

    .info-container {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 5px;
      margin: 20px 0;
    }

    table {
      font-family: arial, sans-serif;
      border-collapse: collapse;
      width: 100%;
    }

    td,
    th {
      border: 1px solid black;
      text-align: left;
      text-overflow: ellipsis;
      font-size: 10px;
      padding: 8px;
      max-width: 100px;
    }

    tr th {
      border-bottom: none;
      border-right: none;
    }

    tr.special-tr:last-child th{
      border-bottom: 2px solid black !important;
    }

    tr td {
      border-bottom: none;
      border-right: none;
    }

    tr:last-child td {
      border-bottom: 2px solid black;
    }

    tr td:last-child {
      border-right: 2px solid black;
    }

    tr td:first-child {
      border-left: 2px solid black;
    }

    tr th:last-child {
      border-right: 2px solid black;
    }

    tr th:first-child {
      border-left: 2px solid black;
    }

    thead tr:first-child {
      border-top: 2px solid black;
      border-bottom: 1px solid black; 
    }

    .my-3 {
      margin: 3rem 0;
    }

    .mt-3 {
      margin-top: 3rem;
    }

    .box-container {
      width: 100%;
      height: 100px;
      border: 2px solid black;
    }

    .header-text {
      text-align: center;
    }

    .no-l-border {
      border-left: none !important;
    }

    .no-r-border {
      border-right: none !important;
    }

    .score-text {
      font-size: 20px;
    }

    .no-break {
      white-space: nowrap;
    }
  </style>
</head>

<body>`;

export const competitionHTML = `<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="UTF-8">
  <title>Proces Verbal - <%= competitionName %></title>
  <style>
    body {
      font-family: Arial, sans-serif;
      color: #000;
    }

    .relative {
      height: 100%;
      width: 100%;
      position: relative;
    }

    h1 {
      font-size: 18px;
      text-align: center;
      color: #000;
      padding-bottom: 20px;
    }

    h2 {
      font-size: 15px;
      color: #000;
    }

    .img-container {
      width: 200px;
      height: auto;
      aspect-ratio: 1;
      position: absolute;
      top: 20px;
      right: 0;
    }

    h2,
    p,
    ul {
      margin-bottom: 10px;
      list-style-type: disc;
    }

    table {
      width: 100%;
      max-width: 100%;
      border-collapse: collapse;
      margin: 20px auto;
      page-break-inside: avoid;
    }

    th,
    td {
      border: 1px solid #000;
      padding: 8px;
      text-align: center;
      font-size: 10px;
    }

    th {
      background-color: #f0f0f0;
    }

    .table-wrapper {
      page-break-before: always;
      page-break-after: auto;
      page-break-inside: avoid;
    }


    @media print {
      body {
        margin: 20px;
      }
    }
  </style>
</head>

<body>`



export let closingHtmlString = `</body>
</html>`;


export let statsTable = `
<table ref="myTable"
class="table-stats table table-bordered dt-responsive table-striped nowrap w-100 ml-0"
>
<thead>
  <tr>
    <th rowspan="2" style="width: 150px; min-width: 150px;">
      {{ $t("menu.team") }}
    </th>
    <th
      v-for="(stage, index) in competition.stages.filter(
        stage => stage.category === category
      )"
      colspan="2"
    >
      {{ $t("competition.stage") }} {{ index + 1 }}
    </th>
    <th colspan="2">{{ $t("competition.total") }}</th>
  </tr>
  <tr>
    <template
      v-for="(stage, index) in competition.stages.filter(
        stage => stage.category === category
      )"
    >
      <th>{{ $t("competition.points") }}</th>
      <th>{{ $t("competition.diff") }}</th>
    </template>
    <th>{{ $t("competition.points") }}</th>
    <th>{{ $t("competition.diff") }}</th>
  </tr>
</thead>
<tbody>
  <template v-for="(team, index) in teams">
    <tr :key="team._id">
      <td>
        <Tooltip
          :content="team.name"
          placement="top-start"
          style="width: 170px;"
        >
          <span
            class="text-overflow-style single-groups-clamp-text w-100"
          >
            {{ team.name }}
          </span>
        </Tooltip>
      </td>
      <template
        v-if="team.statistics"
        v-for="stage in team.statistics ? team.statistics.stages : []"
      >
        <td>
          <span v-if="stage">{{ stage.points }}</span>
          <span v-else></span>
        </td>
        <td>
          <div
            v-if="stage"
            class="d-flex justify-content-between w-100 text-nowrap"
          >
            <span class="mr-2">
              {{ stage.scored }} - {{ stage.conceded }}
            </span>
            <span class="font-weight-bold">
              ({{ displayPlus(stage.scored, stage.conceded) }})
            </span>
          </div>
          <span v-else></span>
        </td>
      </template>
      <td>
        <span v-if="team.statistics">{{
          team.statistics.totalPoints
        }}</span>
      </td>
      <td>
        <div
          v-if="team.statistics"
          class="d-flex justify-content-between w-100 text-nowrap"
        >
          <span class="mr-2">
            {{ team.statistics.totalScored }} -
            {{ team.statistics.totalConceded }}
          </span>
          <span class="font-weight-bold">
            ({{
              displayPlus(
                team.statistics.totalScored,
                team.statistics.totalConceded
              )
            }})
          </span>
        </div>
      </td>
    </tr>
  </template>
</tbody>
</table>`


// WEBPACK FOOTER //
// ./src/components/competitions/brackets/htmlHelpers.js